import React, { useEffect, useState } from 'react'
import { ReactComponent as Remove } from '../../../assets/Remove.svg'
import s from '../CreateQuiz.module.scss'
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { PriceSegmentInput } from './PriceSegmentInput';
export const AirbnbSlider = withStyles({
    root: {
        height: 3,
        padding: '13px 0',
    },
    thumb: {
        height: 27,
        width: 27,
        backgroundColor: '#fff',
        border: '1px solid currentColor',
        marginTop: -12,
        marginLeft: -13,
        boxShadow: '#ebebeb 0 2px 2px',
        '&:focus, &:hover, &$active': {
            boxShadow: '#ccc 0 2px 3px 1px',
        },
        '& .bar': {
            // display: inline-block !important;
            height: 9,
            width: 1,
            backgroundColor: 'currentColor',
            marginLeft: 1,
            marginRight: 1,
        },
    },
})(Slider);

export function ValueLabelComponent(props) {
    const useStyles = makeStyles({
        tooltip: {
            fontSize: '1rem'
        }
    });
    const classes = useStyles();

    const { children, open, value } = props;
    return (
        <Tooltip
            classes={{
                tooltip: classes.tooltip, // class name, e.g. `classes-nesting-root-x`
            }}
            open={open} enterTouchDelay={0} placement="top" title={Math.floor(value)} >
            {children}
        </Tooltip >
    );
}

export const ProductsTable = ({ priceHeaderInput, togglePriceQuestion, segmentItemCounters, calculateSegments, updateButtonSegmentTexts, children, highestPrice, showPriceInput, quiz, setCurrentTableAnswer, removeItem, currentTableAnswer }) => {
    const [formattedHighestPrice, setTheHighestPrice] = useState('')
    const [sliderValues, setValue] = React.useState([quiz.price[1].from || 100, quiz.price[2].from || highestPrice - 50]);
    const [currentSegment, setCurrentSegment] = React.useState(2);
    const [currency] = React.useState(
        quiz.itemsChoices[0][0]?.currency || '$'
    );

    function getFormattedPrice(price) {
        const locale = navigator.language
        const numberToShow = Math.floor(price);
        if (currency === '€' || currency === 'zł') {
            return `${numberToShow.toLocaleString(locale)} ${currency}`;
        } else {
            return `${currency}${numberToShow.toLocaleString(locale)}`;
        }
    }
    useEffect(() => {
        if (currency === '€' || currency === 'zł') {
            setTheHighestPrice(getFormattedPrice(highestPrice))
        } else {
            setTheHighestPrice(getFormattedPrice(highestPrice))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [highestPrice])

    useEffect(() => {
        calculateSegments([quiz.price[1].from, quiz.price[2].from])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function setFocusedCube(e) {
        const values = e.target.attributes['data-id'] ?
            e.target.attributes['data-id'] :
            e.target.parentElement.attributes['data-id']
        if (!values || showPriceInput) {
            setCurrentTableAnswer('')
            return;
        }
        setCurrentTableAnswer(values.value.split(' '))
    }

    const handleChange = (event, newValue) => {
        newValue.forEach((value) => {
            value = Math.floor(value)
        })
        setValue(newValue);
        calculateSegments(newValue);
    };

    const segmentButtons = [
        {
            text: `$0 - ${getFormattedPrice(sliderValues[0])}`,
            key: 1
        },
        {
            text: `${getFormattedPrice(sliderValues[0])} - ${getFormattedPrice(sliderValues[1])}`,
            key: 2
        },
        {
            text: `${getFormattedPrice(sliderValues[1])} - ${formattedHighestPrice}`,
            key: 3
        },
    ]

    const marks = [
        {
            value: 0,
            label: '0',
        },
        {
            value: highestPrice,
            label: formattedHighestPrice,
        },
    ];

    const buttonTextInputs = [
        {
            placeholder: 'Text for button',
            defaultPriceText: `< ${getFormattedPrice(sliderValues[0])}`,
            text: quiz.price[0].title || `< ${getFormattedPrice(sliderValues[0])}`,
            key: '1'
        },
        {
            placeholder: 'Text for button',
            defaultPriceText: `${getFormattedPrice(sliderValues[0])} - ${getFormattedPrice(sliderValues[1])}`,
            text: quiz.price[1].title || `${getFormattedPrice(sliderValues[0])} - ${getFormattedPrice(sliderValues[1])}`,
            key: '2'
        },
        {
            placeholder: 'Text for button',
            defaultPriceText: `> ${getFormattedPrice(sliderValues[1])}`,
            text: quiz.price[2].title || `> ${getFormattedPrice(sliderValues[1])}`,
            key: '3'
        },
    ]

    function changeCurrentSegment(e) {
        setCurrentSegment(JSON.parse(e.target.value))
    }
    const showTextError = segmentItemCounters[1] || segmentItemCounters[2] || segmentItemCounters[3];
    return (
        <div style={{
            backgroundColor: 'white',
            padding: '24px',
        }}>
            {showPriceInput ?
                PriceSegmentInput(quiz, togglePriceQuestion, priceHeaderInput, marks, sliderValues, handleChange, highestPrice, segmentButtons, changeCurrentSegment, segmentItemCounters, currentSegment, showTextError, buttonTextInputs, updateButtonSegmentTexts)
                : null
            }
            <table className={`table-bordered`}
            >
                <thead>
                    <tr>
                        <th scope="col" style={{
                            textAlign: 'center',
                            backgroundColor: '#F3F3F3',
                            fontWeight: '400',
                            fontSize: '16px'
                        }}>#</th>
                        {quiz.questions[1].answers.map(choice => <th key={choice.title} style={{
                            textAlign: 'center',
                            backgroundColor: '#F3F3F3',
                            fontWeight: '400',
                            fontSize: '16px'
                        }} scope="col">{choice.title}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {quiz.questions[0].answers && quiz.questions[0].answers.length ?
                        quiz.questions[0].answers.map((choice, firstQuestionIndex) =>
                            <tr key={choice.title}>
                                <th scope="row" style={{
                                    backgroundColor: '#FDFDFD',
                                    fontWeight: '400',
                                    fontSize: '16px',
                                }}>
                                    {choice.title}
                                </th>
                                {quiz.itemsChoices[firstQuestionIndex].map((cellOfItems, secondQuestionIndex) =>
                                    <th
                                        key={`${firstQuestionIndex}-${secondQuestionIndex}`}
                                        data-id={`${firstQuestionIndex} ${secondQuestionIndex}`}
                                        scope="row" onClick={setFocusedCube}
                                        style={{
                                            zIndex: '3',
                                            padding: '20px',
                                            backgroundColor:
                                                JSON.stringify(firstQuestionIndex) === currentTableAnswer[0] &&
                                                    JSON.stringify(secondQuestionIndex) === currentTableAnswer[1] ? '#3699ff08' :
                                                    cellOfItems.countOfSegment && !cellOfItems.countOfSegment[currentSegment] && showPriceInput ? '#fff5f6' :
                                                        'initial'

                                        }}
                                    >
                                        {cellOfItems.length ?
                                            itemsCell(cellOfItems, firstQuestionIndex, secondQuestionIndex, removeItem, setFocusedCube, currentSegment, showPriceInput)
                                            :
                                            <button
                                                data-id={`${firstQuestionIndex} ${secondQuestionIndex}`}
                                                style={{
                                                    padding: '16px',
                                                    margin: 'auto',
                                                    display: 'block',
                                                }}
                                                className="btn btn-outline-primary border-style-dashed">+ Add Products
                                            </button>
                                        }
                                    </th>
                                )
                                }
                            </tr>
                        )
                        :
                        null
                    }
                </tbody>
            </table>
            {children}
        </div >
    )
}
function itemsCell(items, firstQuestionIndex, secondQuestionIndex, removeItem, setFocusedCube, currentSegment, showPriceInput) {
    return <div>
        <div style={{
            display: 'flex',
            flexFlow: 'wrap',
        }} className={s.gridGap} data-id={`${firstQuestionIndex} ${secondQuestionIndex}`} onClick={setFocusedCube}>
            {items.map(item => itemOfEachCell(item, firstQuestionIndex, secondQuestionIndex, removeItem, currentSegment, showPriceInput)
            )}
        </div>
    </div>;
}

function itemOfEachCell(item, firstQuestionIndex, secondQuestionIndex, removeItem, currentSegment, showPriceInput) {
    return <div
        key={item.itemId}
        data-id={`${firstQuestionIndex} ${secondQuestionIndex} ${item.itemId}`}
        alt={item.title}
        title={`${item.title} ${item.price}`}
        style={{
            backgroundImage: `url(${item.img})`,
            height: '56px',
            width: '44px',
            backgroundSize: 'cover',
            position: 'relative',
            border: '0.5px dashed #000000',
            borderRadius: '4px',
            opacity: (item.segment && item.segment === currentSegment) || !showPriceInput ? '1' : '0.2'
        }}
    >
        {!showPriceInput &&
            <Remove
                onClick={removeItem}
                data-id={`${firstQuestionIndex} ${secondQuestionIndex} ${item.itemId}`}
                style={{
                    position: 'absolute',
                    top: '-5px',
                    right: '-5px',
                    cursor: 'pointer',
                }} />
        }
    </div>;
}
